var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPictureFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    viewBox: "3.6 14.46 91.89 68.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.994,39.347c0,4.793-3.887,8.681-8.683,8.681c-4.787,0-8.683-3.888-8.683-8.681c0-4.8,3.896-8.683,8.683-8.683   C37.106,30.664,40.994,34.547,40.994,39.347z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.667,14.456c-3.828,0-84.239,0-84.239,0s-3.829,0-3.829,3.829c0,3.833,0,61.266,0,61.266s0,3.825,3.829,3.825   c3.83,0,84.239,0,84.239,0s3.822,0,3.822-3.825c0-3.832,0-61.266,0-61.266S95.489,14.456,91.667,14.456z M87.839,75.718H11.258   V22.117h76.581V75.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.778,69.215c0,0-3.58-20.746-14.327-20.746c-10.739,0-14.327,13.835-21.479,13.835c-7.176,0-7.176-3.463-14.327-3.463   c-7.168,0-14.335,10.373-14.335,10.373H81.778z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPictureFrame);
export default __webpack_public_path__ + "static/media/icon-picture-frame.73917258f3ade5503a531024403345ed.svg";
export { ForwardRef as ReactComponent };